import * as React from "react";
type Props = {
  className?: string,
};
function SvgFeeds3({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Feeds 3"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1244 21.8009C18.0554 21.8009 16.3704 20.3739 16.3704 18.6219H16.9854C16.9854 20.0359 18.3944 21.1859 20.1244 21.1859C21.8554 21.1859 23.2644 20.0359 23.2644 18.6219H23.8794C23.8794 20.3739 22.1944 21.8009 20.1244 21.8009Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.871 18.4611C27.902 18.3471 27.933 18.2321 27.96 18.1161C27.932 18.2321 27.902 18.3471 27.871 18.4611ZM28.792 5.30713C26.133 5.30713 23.783 6.60313 22.318 8.59013C21.62 8.39313 20.887 8.28013 20.124 8.28013C19.398 8.28013 18.697 8.38513 18.028 8.56613C16.557 6.64913 14.251 5.40713 11.649 5.40713C7.20598 5.40713 3.60498 9.00813 3.60498 13.4501C3.60498 17.8931 7.20598 21.4941 11.649 21.4941C12.375 21.4941 13.076 21.3891 13.745 21.2081C15.215 23.1251 17.522 24.3661 20.124 24.3661C22.784 24.3661 25.133 23.0701 26.598 21.0811C27.296 21.2801 28.03 21.3921 28.792 21.3921C33.234 21.3921 36.835 17.7911 36.835 13.3501C36.835 8.90713 33.234 5.30713 28.792 5.30713Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.289 21.8472C13.445 21.6242 12.563 21.4932 11.649 21.4932C5.93701 21.4932 1.30701 26.1232 1.30701 31.8342H10.196C11.33 27.9082 14.723 24.9482 18.879 24.4472C18.798 24.3682 18.708 24.2982 18.624 24.2212C16.93 23.9012 15.428 23.0502 14.289 21.8472Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.9317 15.6477C31.9317 17.0627 30.5237 18.2137 28.7927 18.2137C28.5027 18.2137 28.2277 18.1707 27.9607 18.1097C27.9157 18.3107 27.8687 18.5087 27.8087 18.7027C28.1237 18.7767 28.4497 18.8277 28.7927 18.8277C30.8617 18.8277 32.5467 17.4007 32.5467 15.6477H31.9317Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3237 18.2507C12.1067 18.2907 11.8807 18.3137 11.6487 18.3137C9.91668 18.3137 8.50868 17.1637 8.50868 15.7487H7.89368C7.89368 17.5017 9.57868 18.9287 11.6487 18.9287C11.9387 18.9287 12.2177 18.8947 12.4887 18.8417C12.4257 18.6477 12.3727 18.4507 12.3237 18.2507Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1259 24.3663C20.3129 24.3663 20.4969 24.3513 20.6809 24.3383C20.6699 24.3483 20.6579 24.3573 20.6469 24.3673C20.7029 24.3753 20.7549 24.3923 20.8109 24.4013C20.5829 24.3863 20.3569 24.3663 20.1259 24.3663ZM18.6249 24.2213C19.1109 24.3133 19.6109 24.3663 20.1239 24.3663C19.7019 24.3663 19.2879 24.3993 18.8789 24.4483C18.7979 24.3683 18.7089 24.2983 18.6249 24.2213ZM39.1329 31.7283C39.1329 26.0183 34.2699 21.3883 28.2709 21.3883C27.5499 21.3883 26.8559 21.4793 26.1759 21.6093C27.4119 20.1953 28.1669 18.3493 28.1669 16.3223C28.1669 11.8813 24.5659 8.28033 20.1249 8.28033C15.6829 8.28033 12.0819 11.8813 12.0819 16.3223C12.0819 18.4643 12.9239 20.4053 14.2889 21.8473C13.4449 21.6243 12.5629 21.4933 11.6479 21.4933C5.93786 21.4933 1.30786 26.1233 1.30786 31.8343H10.1969C9.93286 32.7473 9.78386 33.7093 9.78386 34.7063H30.4649C30.4649 33.6713 30.3089 32.6723 30.0249 31.7283H39.1329Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.4653 34.7068C30.4653 28.9958 25.8352 24.3668 20.1252 24.3668C19.7022 24.3668 19.2883 24.3998 18.8783 24.4488C18.7973 24.3678 18.7083 24.2978 18.6243 24.2208C16.9303 23.9008 15.4283 23.0498 14.2893 21.8468C13.4453 21.6238 12.5623 21.4938 11.6483 21.4938C5.93725 21.4938 1.30725 26.1228 1.30725 31.8338H10.1963C9.93225 32.7478 9.78325 33.7088 9.78325 34.7068H30.4653Z"
        stroke="currentColor"
      />
    </svg>
  );
}
export default SvgFeeds3;
